import { render, staticRenderFns } from "./GovId.vue?vue&type=template&id=07060594&scoped=true"
import script from "./GovId.vue?vue&type=script&lang=js"
export * from "./GovId.vue?vue&type=script&lang=js"
import style0 from "./GovId.vue?vue&type=style&index=0&id=07060594&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07060594",
  null
  
)

export default component.exports